import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Broker } from './broker-settings.model';
import { environment} from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class BrokerSettingsService {
  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  postBroker(broker: Broker): Observable<any> {
    return this.http.post(this.url + 'brokers', broker);
  }

  putBroker(broker: Broker): Observable<any> {
    return this.http.put(this.url + 'brokers', broker);
  }

  deleteBroker(index: number): Observable<any> {
    return this.http.delete(this.url + 'brokers/' + index);
  }

  fetchBrokers(): Observable<any> {
    return this.http.get(this.url + 'brokers');
  }
}
